export const autocaller_v2 = {
  name: 'predictive',
  title: 'autocaller_v2.breadcrumb.title',
  icon: () => import('@shared/components/icon/sidebar/icon-predictive.vue'),
  route: { name: 'autocaller_v2.module' },
  children: [
    {
      title: 'autocaller_v2.breadcrumb.campaign.index',
      route: { name: 'autocaller_v2.campaign.index' },
      routes: [{ name: 'autocaller_v2.campaign.new' }]
    },
    {
      title: 'autocaller_v2.breadcrumb.operators.index',
      route: { name: 'autocaller_v2.operators.index' }
    },
    {
      title: 'autocaller_v2.monitoring_general.index.title',
      route: { name: 'autocaller_v2.monitoring_general.index' }
    },
    {
      title: 'shared.breadcrumb.stats.title',
      route: { name: 'autocaller_v2.stats.type', params: { type: 'detailed' } }
    },
    {
      title: 'autocaller_v2.breadcrumb.settings.index',
      route: { name: 'autocaller_v2.settings.type', params: { type: 'webhook' } }
    }
  ]
};
